/**
 * The disclaimer shown wherever the application presents AI-generated output.
 *
 * Legal drafted and approved this sentence, so it is quoted here exactly as
 * they wrote it and is not paraphrased, shortened or split at the call site.
 * It lives beside the versioned policy documents because the same wording is
 * carried into the Terms of Use, and one copy of a legal sentence beats two
 * that can drift.
 *
 * Unlike the documents in this directory it carries no version and nobody
 * accepts it: it is a standing notice on the screen, not a record of consent.
 */
export const AI_OUTPUT_DISCLAIMER =
  "AI-generated outputs may contain inaccuracies and do not constitute legal " +
  "advice. They should not be relied upon without human review.";
